module.exports = __webpack_public_path__ + "static/media/city.027b1f0d.png";